(function () {
  class SlSetupGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.slider = this.querySelector('[data-sl-setup-guide-slider]');
      this.progressTrack = this.querySelector('.sl-setup-guide__progress');
      this.progressFill = this.querySelector('[data-sl-setup-guide-progress-fill]');
      this.boundHandleResize = this.handleResize.bind(this);
      this.boundUpdateProgress = this.updateProgress.bind(this);

      window.addEventListener('resize', this.boundHandleResize);
      this.handleResize();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.destroySwiper();
    }

    handleResize() {
      if (!this.slider || typeof window.Swiper === 'undefined') return;

      const shouldEnableSlider = window.innerWidth <= 1024;

      if (shouldEnableSlider && !this.swiper) {
        this.createSwiper();
      } else if (!shouldEnableSlider && this.swiper) {
        this.destroySwiper();
      } else if (this.swiper) {
        this.swiper.update();
        this.updateProgress();
      }
    }

    createSwiper() {
      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 600,
        watchOverflow: true,
        on: {
          init: () => this.updateProgress(),
          resize: () => this.updateProgress(),
          setTranslate: () => this.updateProgress(),
          transitionEnd: () => this.updateProgress()
        }
      });

      window.addEventListener('resize', this.boundUpdateProgress);
    }

    destroySwiper() {
      window.removeEventListener('resize', this.boundUpdateProgress);

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      if (this.progressFill) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
      }
    }

    updateProgress() {
      if (!this.progressTrack || !this.progressFill || !this.swiper) return;

      const snapCount = this.swiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, this.swiper.width / this.swiper.virtualSize);
      const trackWidth = this.progressTrack.clientWidth || 100;
      const thumbWidth = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = this.swiper.minTranslate ? this.swiper.minTranslate() : 0;
      const maxTranslate = this.swiper.maxTranslate ? this.swiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - this.swiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travel = Math.max(0, trackWidth - thumbWidth);

      this.progressFill.style.width = `${thumbWidth}px`;
      this.progressFill.style.transform = `translateX(${travel * progress}px)`;
    }
  }

  if (!customElements.get('sl-setup-guide')) {
    customElements.define('sl-setup-guide', SlSetupGuide);
  }
})();
